import { createUseQueryHook } from 'hooks/createUseQueryHook';

export const useEmployeeList = createUseQueryHook(
    'employee_list',
    { keepPreviousData: true },
);
